"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var qTransform = {
  "38": "translate(1, 1) scale(0.357)",
  "70": "translate(3, 3) scale(0.598)",
  "90": "translate(3, 2) scale(0.735)",
  "120": ""
};
var propTypes = {
  /** Size of chip  */
  size: (0, _propTypes.oneOf)(["38", "70", "90", "120"]).isRequired
};

var QLogo = function QLogo(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    id: "QLogo",
    transform: qTransform[size]
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.1028496,34.8798111 L29.9926613,29.331573 C29.8079632,28.8663874 29.4390703,28.4499018 28.6127099,28.4499018 L25.852807,28.4499018 C25.1628313,28.4499018 24.6097436,28.9150873 24.9303231,29.7962513 L27.7194153,37.0926131 C26.7969314,37.3234303 25.8155655,37.4456874 24.7939384,37.4456874 C17.9837624,37.4456874 13.1539324,32.0684062 13.1539324,25.0175731 C13.1539324,17.970291 17.9837624,12.5889515 24.7939384,12.5889515 C31.6005916,12.5889515 36.4339444,17.970291 36.4339444,25.0175731 C36.4339444,29.1119161 34.8033673,32.6375863 32.1028496,34.8798111 M24.7939384,8 C15.500655,8 8,15.2816504 8,25.0175731 C8,34.7570468 15.500655,42.0386972 24.7939384,42.0386972 C26.3842544,42.0386972 27.9192113,41.8195476 29.3721361,41.4177734 L31.1879147,46.1665214 C31.3721095,46.6763485 31.7410024,47 32.4309781,47 L35.3267624,47 C36.0167381,47 36.5265451,46.5348144 36.2014362,45.6536505 L33.8401189,39.4428908 C38.4998455,36.490459 41.584354,31.2613067 41.584354,25.0175731 C41.584354,15.2816504 34.0877251,8 24.7939384,8"
  }));
};

QLogo.propTypes = propTypes;
QLogo.displayName = "Modules.QLogo";
var _default = QLogo;
exports["default"] = _default;